(function () {
  'use strict';

  const API_URL = (window.WiderrufsConfig || {}).apiUrl || 'https://api.efficient-flow.de/widerruf/submit';

  const step1 = document.getElementById('widerruf-step-1');
  const step2 = document.getElementById('widerruf-step-2');
  const step3 = document.getElementById('widerruf-step-3');
  const form = document.getElementById('widerruf-form');
  const backBtn = document.getElementById('widerruf-back-btn');
  const confirmBtn = document.getElementById('widerruf-confirm-btn');
  const sendingIndicator = document.getElementById('widerruf-sending');
  const errorMsg = document.getElementById('widerruf-error-msg');
  const errorDetail = document.getElementById('widerruf-error-detail');

  if (!form) return;

  // -- Validation --

  function validateField(input) {
    const errorEl = document.getElementById(input.id + '-error');
    if (!errorEl) return true;

    let msg = '';
    if (input.required && !input.value.trim()) {
      msg = 'Dieses Feld ist erforderlich.';
    } else if (input.type === 'email' && input.value.trim()) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) {
        msg = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
      }
    }

    errorEl.textContent = msg;
    input.classList.toggle('widerruf-input--error', !!msg);
    return !msg;
  }

  function validateAll() {
    const fields = form.querySelectorAll('input[required], input[type="email"]');
    let valid = true;
    fields.forEach(function (f) {
      if (!validateField(f)) valid = false;
    });
    return valid;
  }

  // Live validation on blur
  form.querySelectorAll('input').forEach(function (input) {
    input.addEventListener('blur', function () { validateField(input); });
  });

  // -- Step 1 → Step 2: show summary --

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validateAll()) return;

    document.getElementById('summary-name').textContent = form.querySelector('#widerruf-name').value.trim();
    document.getElementById('summary-order').textContent = form.querySelector('#widerruf-order').value.trim();
    document.getElementById('summary-email').textContent = form.querySelector('#widerruf-email').value.trim();

    hideErrorMsg();
    step1.classList.add('widerruf-step--hidden');
    step2.classList.remove('widerruf-step--hidden');
    window.scrollTo({ top: step2.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  });

  // -- Step 2 → Step 1: back --

  backBtn.addEventListener('click', function () {
    step2.classList.add('widerruf-step--hidden');
    step1.classList.remove('widerruf-step--hidden');
  });

  // -- Step 2 → Step 3: submit --

  confirmBtn.addEventListener('click', function () {
    confirmBtn.disabled = true;
    backBtn.disabled = true;
    sendingIndicator.classList.remove('widerruf-step--hidden');
    hideErrorMsg();

    const payload = {
      name: form.querySelector('#widerruf-name').value.trim(),
      order_number: form.querySelector('#widerruf-order').value.trim(),
      email: form.querySelector('#widerruf-email').value.trim(),
    };

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (resp) {
        if (!resp.ok) {
          return resp.json().catch(function () { return {}; }).then(function (body) {
            throw new Error(body.detail || 'HTTP ' + resp.status);
          });
        }
        return resp.json();
      })
      .then(function () {
        document.getElementById('success-email').textContent = payload.email;
        step2.classList.add('widerruf-step--hidden');
        step3.classList.remove('widerruf-step--hidden');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function (err) {
        confirmBtn.disabled = false;
        backBtn.disabled = false;
        sendingIndicator.classList.add('widerruf-step--hidden');
        showErrorMsg(err.message || '');
      });
  });

  function showErrorMsg(detail) {
    errorDetail.textContent = detail ? ' ' + detail + '.' : '';
    errorMsg.classList.remove('widerruf-step--hidden');
  }

  function hideErrorMsg() {
    errorMsg.classList.add('widerruf-step--hidden');
  }
})();
